<template>
    <PopoverRight ref="popoverMenu" width="720px">
        <div class="popover-slider-bar">
            <h1 class="bar-title">正文插入楼盘</h1>
            <p class="remark">内容添加说明：支持动态取值的字段名称及取值示范，可点击<span @click="showTagLib"
                    style="color:rgb(0 85 245);cursor: pointer;">“动态取值标签库”</span> 进行查看。</p>
            <el-form class="form-container" :model="info" :rules="insertRules" ref="insetInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">楼盘调用规则</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="rules_id">
                            <el-select v-model="info.rules_id" placeholder="全部" @change="changeRule">
                                <el-option v-for="item in rulesList" :key="item.id" :label="item.rule_name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <p class="tip" v-if="info.rules_id">此类规则适用于：{{ ruleInfo }}</p>
                    </div>
                </div>
                <template v-if="info.rules_id == 11">
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">销售状态</span>
                        </div>
                        <div class="form-input-item">
                            <el-form-item label="" prop="condition.sale_info">
                                <el-checkbox-group v-model="info.condition.sale_info">
                                    <el-checkbox v-for="item in saleInfoList" :label="item.id"
                                        :key="item.id">{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">区域</span>
                        </div>
                        <div class="form-input-item">
                            <el-form-item label="" prop="condition.district">
                                <el-checkbox-group v-model="info.condition.district">
                                    <el-checkbox :disabled="info.condition.subway == 1" label="1">随机一个区域</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">地铁线路</span>
                        </div>
                        <div class="form-input-item">
                            <el-form-item label="" prop="">
                                <el-checkbox-group v-model="info.condition.subway">
                                    <el-checkbox :disabled="info.condition.district == 1" label="1">随机一条线路</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">户型</span>
                        </div>
                        <div class="form-input-item">
                            <el-form-item label="" prop="">
                                <el-checkbox-group v-model="info.condition.layout">
                                    <el-checkbox v-for="item in layoutList" :label="item.id"
                                        :key="item.id">{{ item.name }}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">物业</span>
                        </div>
                        <div class="form-input-item">
                            <el-form-item label="" prop="">
                                <el-checkbox-group v-model="info.condition.type_id">
                                    <el-checkbox v-for="item in typeIdList" :label="item.id"
                                        :key="item.id">{{ item.name }}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">单价区间</span>
                        </div>
                        <div class="form-input-item rangePrice clearfix">
                            <el-form-item label="" prop="condition.price_start">
                                <el-input v-model="info.condition.price_start" style="width:120px" :disabled="selecTotalPrice"></el-input>
                                <span style="margin-left: 20px;">-</span>
                            </el-form-item>
                            <el-form-item label="" prop="condition.price_end">
                                <el-input v-model="info.condition.price_end" style="width:120px" :disabled="selecTotalPrice"></el-input><span
                                    style="margin-left:10px">元/㎡</span>
                            </el-form-item>
                            <el-form-item label="" prop="condition.price_rand" style="margin-left: 20px;">
                                <el-checkbox-group v-model="info.condition.price_rand">
                                    <el-checkbox label="1" :disabled="checkTotalPrice">随机单价区间</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">总价区间</span>
                        </div>
                        <div class="form-input-item rangePrice clearfix">
                            <el-form-item label="" prop="condition.total_price_start">
                                <el-input v-model="info.condition.total_price_start" style="width:120px" :disabled="selecPrice"></el-input>
                                <span style="margin-left: 20px;">-</span>
                            </el-form-item>
                            <el-form-item label="" prop="condition.total_price_end">
                                <el-input v-model="info.condition.total_price_end" style="width:110px" :disabled="selecPrice"></el-input><span
                                    style="margin-left:10px">万元/套</span>
                            </el-form-item>
                            <el-form-item label="" prop="condition.total_price_rand" style="margin-left: 20px;">
                                <el-checkbox-group v-model="info.condition.total_price_rand">
                                    <el-checkbox label="1" :disabled="checkPrice">随机总价区间</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">建面区间</span>
                        </div>
                        <div class="form-input-item rangePrice clearfix">
                            <el-form-item label="" prop="condition.area_start">
                                <el-input v-model="info.condition.area_start" style="width:120px" :disabled="info.condition.area_rand == 1"></el-input>
                                <span style="margin-left: 20px;">-</span>
                            </el-form-item>
                            <el-form-item label="" prop="condition.area_end">
                                <el-input v-model="info.condition.area_end" style="width:120px" :disabled="info.condition.area_rand == 1"></el-input><span
                                    style="margin-left:10px">m²</span>
                            </el-form-item>
                            <el-form-item label="" prop="highest_price" style="margin-left: 20px;">
                                <el-checkbox-group v-model="info.condition.area_rand">
                                    <el-checkbox label="1">随机建面区间</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                </template>
                <div class="form-item" v-if="info.rules_id == 8">
                    <div class="form-label">
                        <span class="label">价格区间</span>
                    </div>
                    <div class="form-input-item rangePrice clearfix">
                        <el-form-item label="" prop="lowest_price">
                            <el-input v-model="info.lowest_price" style="width:120px"></el-input>
                            <span style="margin-left: 20px;">-</span>
                        </el-form-item>

                        <el-form-item label="" prop="highest_price">
                            <el-input v-model="info.highest_price" style="width:120px"></el-input><span
                                style="margin-left:10px">元/㎡</span>
                        </el-form-item>
                        <br>
                        <p class="tip2">可填写起始区间进行查询，不填时会随机一个价格区间</p>
                    </div>

                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">楼盘调用数量</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="num">
                            <el-input placeholder="可输入1-10" v-model="info.num">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item" v-if="info.rules_id == 10">
                    <div class="form-label">
                        <span class="label">时间段</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item>
                            <el-select v-model="timeId">
                                <el-option label="最近一个月" value='1'></el-option>
                                <el-option label="最近三个月" value='2'></el-option>
                                <el-option label="最近半年" value='3'></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">楼盘展示内容</span>
                        <label class="warn">*</label>
                    </div>
                </div>
                <div class="form-item">
                    <el-form-item style="width:650px;">
                        <UEH :options="eidtorOptions" defaultMsg="" ref="ueHouse" />
                    </el-form-item>

                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('insetInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
import { getHouseRule, insertHouse, getInsertHouse, editInsertHouse } from '@/service/newsModel'
import PopoverRight from '@/components/popoverRight/index'
import { UPLOAD_CODE } from "@/config/index";
import UEH from '@/components/editoritem/uEditorHouse';

export default {
    name: "insertHouse",
    components: {
        PopoverRight,
        UEH
    },
    data() {
        const validateSort = (rule, value, callback) => {
            if (/^-?\d+$/.test(value) === false || value < 1 || value > 10) {
                callback(new Error(`请输入1-10之间的数字`))
            } else {
                callback()
            }
        }
        const validateRange = (rule, value, callback) => {
            if (parseInt(this.info.lowest_price) >= parseInt(this.info.highest_price)) {
                callback(new Error(rule.type === 'max' ? `最高价格必须大于最低价格` : `最低价格必须小于最高价格`))
            } else {
                callback()
            }
        }
        // const validatePrice = (rule, value, callback) => {
        //     if (parseInt(this.info.condition.price_start) >= parseInt(this.info.condition.price_end)) {
        //         callback(new Error(rule.type === 'max' ? `最高价格必须大于最低价格` : `最低价格必须小于最高价格`))
        //     } else {
        //         callback()
        //     }
        // }
        // const validateTotlePrice = (rule, value, callback) => {
        //     if (parseInt(this.info.condition.total_price_start) >= parseInt(this.info.condition.total_price_end)) {
        //         callback(new Error(rule.type === 'max' ? `最高价格必须大于最低价格` : `最低价格必须小于最高价格`))
        //     } else {
        //         callback()
        //     }
        // }
        // const validateArea = (rule, value, callback) => {
        //     if (parseInt(this.info.condition.area_start) >= parseInt(this.info.condition.area_end)) {
        //         callback(new Error(rule.type === 'max' ? `最高建面必须大于最低建面` : `最低建面必须小于最高建面`))
        //     } else {
        //         callback()
        //     }
        // }
        return {
            stateOfSales: [],
            // isDistrict:false,                    
            // isSubway:false,
            info: {
                rules_id: '',
                num: '',
                content: '',
                highest_price: '',
                lowest_price: '',
                condition: {
                    sale_info: [],
                    district: "",
                    subway: "",
                    layout: [],
                    type_id: [],
                    price_start: "",
                    price_end: "",
                    price_rand: false,
                    total_price_start:"",
                    total_price_end: "",
                    total_price_rand:false,
                    area_start: "",
                    area_end: "",
                    area_rand: false
                },
            },
            saleInfoList: [{
                id: "1",
                name: "在售"
            }, {
                id: "2",
                name: "待售"
            }, {
                id: "3",
                name: "售完"
            }, {
                id: "4",
                name: "尾盘"
            }],
            layoutList: [{
                id: "1",
                name: "一居"
            }, {
                id: "2",
                name: "二居"
            }, {
                id: "3",
                name: "三居"
            }, {
                id: "4",
                name: "四居"
            }, {
                id: "5",
                name: "五局及以上"
            }],
            typeIdList: [{
                id: "1",
                name: "住宅"
            }, {
                id: "2",
                name: "别墅"
            }, {
                id: "3",
                name: "写字楼"
            }, {
                id: "4",
                name: "商铺"
            }, {
                id: "5",
                name: "仓库"
            }, {
                id: "6",
                name: "厂房"
            }, {
                id: "7",
                name: "城市综合体"
            }, {
                id: "8",
                name: "商业综合体"
            }, {
                id: "9",
                name: "公寓"
            }],
            timeId: '1',
            cardId: null,
            rulesList: [],
            ruleInfo: "",
            insertRules: {
                num: [
                    { required: true, message: '楼盘调用数量', trigger: 'blur' },
                    { validator: validateSort, trigger: "blur" }
                ],
                rules_id: [{ required: true, message: "请选择楼盘调用规则", trigger: "change" }],
                lowest_price: [
                    { validator: validateRange, trigger: 'blur', type: 'min' }
                ],
                highest_price: [
                    { validator: validateRange, trigger: 'blur', type: 'max' }
                ],
                // "condition.price_start":[
                //     { validator: validatePrice, trigger: 'blur', type: 'min' }
                // ],
                // "condition.price_end":[
                //     { validator: validatePrice, trigger: 'blur', type: 'max' }
                // ],
                // "condition.total_price_start":[
                //     { validator: validateTotlePrice, trigger: 'blur', type: 'min' }
                // ],
                // "condition.total_price_end":[
                //     { validator: validateTotlePrice, trigger: 'blur', type: 'max' }
                // ],
                // "condition.area_start":[
                //     { validator: validateArea, trigger: 'blur', type: 'min' }
                // ],
                // "condition.area_end":[
                //     { validator: validateArea, trigger: 'blur', type: 'max' }
                // ]
                
            },
            // 编辑器配置
            eidtorOptions: {
                pictureConfig: {
                    code: UPLOAD_CODE.news
                },
                videoConfig: {
                    code: UPLOAD_CODE.newsVideo
                },
                wordLimit: 12000,
                uploadType: 'common',
                config: {
                    items: ['source', '|', 'undo', 'redo', '|', 'justifyleft', 'justifycenter', 'justifyright', '|', 'forecolor', 'bold', 'selectall', 'removeformat', 'clearhtml', 'quickformat', '|', 'picture', 'link', 'unlink', 'video', 'table', 'fullscreen', 'addIframe'],
                }
            },
        }
    },
    computed:{
        selecPrice(){
            return (this.info.condition.total_price_rand == 1 
                    || this.info.condition.price_rand == 1 
                    || this.info.condition.price_start >0
                    || this.info.condition.price_end > 0) 
        },
        selecTotalPrice(){
            return (this.info.condition.total_price_rand == 1 
                    || this.info.condition.price_rand == 1 
                    || this.info.condition.total_price_start >0
                    || this.info.condition.total_price_end >0) 
        },
        checkPrice(){
            return (this.info.condition.price_rand == 1 
                    || this.info.condition.price_start >0
                    || this.info.condition.price_end >0) != 0
        },
        checkTotalPrice(){
            return (this.info.condition.total_price_rand == 1 
                    || this.info.condition.total_price_start >0
                    || this.info.condition.total_price_end > 0) != 0
        }
    },
    watch:{
        ['info.condition.price_rand']:{
            handler: function(newVal) {
                if(newVal){
                    this.info.condition.price_start = ''
                    this.info.condition.price_end = ''
                }
            },
            immediate: true,
            deep:true
        },
        ['info.condition.total_price_rand']:{
            handler: function(newVal) {
                if(newVal){
                    this.info.condition.total_price_start = ''
                    this.info.condition.total_price_end = ''
                }
            },
            immediate: true,
            deep:true
        },
        ['info.condition.area_rand']:{
            handler: function(newVal) {
                if(newVal){
                    this.info.condition.area_start = ''
                    this.info.condition.area_end = ''
                }
            },
            immediate: true,
            deep:true
        },
    },
    mounted() {
    },
    methods: {
        async open(id) {
            await this.getHouseRules()
            if (id != null && id != '') {
                this.cardId = id;
                this.getInsertHouseInfo(id)
            }
            this.$refs.popoverMenu && this.$refs.popoverMenu.open()
        },
        /** 关闭右侧悬浮层 */
        hide() {
            this.resetForm();
            this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            this.$refs.catInfoForm && this.$refs.catInfoForm.clearValidate()
        },
        resetForm() {
            this.info = {
                rules_id: '',
                num: '',
                content: '',
                highest_price: '',
                lowest_price: '',
                condition: {
                    sale_info: [],
                    district: "",
                    subway: "",
                    layout: [],
                    type_id: [],
                    price_start: "",
                    price_end: "",
                    price_rand: false,
                    total_price_start: "",
                    total_price_end: "",
                    total_price_rand: false,
                    area_start: "",
                    area_end: "",
                    area_rand: false
                },
            }
        },
        showTagLib() {
            this.$emit("showTagLib")
        },
        async getHouseRules() {
            await getHouseRule({}).then((data) => {
                this.rulesList = data
            });

        },
        async getInsertHouseInfo(id) {
            await getInsertHouse(id).then((data) => {
                let info = data;
                if (data.highest_price == 0) {
                    info.highest_price = '';
                }
                if (data.lowest_price == 0) {
                    info.lowest_price = '';
                }
                if(info.condition){
                    info.condition.sale_info = info.condition.sale_info?info.condition.sale_info.toString().split("_"):[]
                    info.condition.district = Number(info.condition.district)? true:false
                    info.condition.subway = Number(info.condition.subway)? true:false
                    info.condition.layout = info.condition.layout?info.condition.layout.toString().split("_"):[]
                    info.condition.type_id = info.condition.type_id?info.condition.type_id.toString().split("_"):[]
                    info.condition.price_start = info.condition.price_start
                    info.condition.price_end = info.condition.price_end
                    info.condition.price_rand = Number(info.condition.price_rand)? true:false
                    info.condition.total_price_start = info.condition.total_price_start
                    info.condition.total_price_end = info.condition.total_price_end
                    info.condition.total_price_rand = Number(info.condition.total_price_rand)? true:false
                    info.condition.area_start = info.condition.area_start
                    info.condition.area_end = info.condition.area_end
                    info.condition.area_rand = Number(info.condition.area_rand)? true:false
                }else{
                    info.condition={
                        sale_info: [],
                        district: "",
                        subway: "",
                        layout: [],
                        type_id: [],
                        price_start: "",
                        price_end: "",
                        price_rand: false,
                        total_price_start: "",
                        total_price_end: "",
                        total_price_rand: false,
                        area_start: "",
                        area_end: "",
                        area_rand: false
                    }
                }
                this.info = info
                let item = this.rulesList.filter(item => item.id == data.rules_id)
                this.ruleInfo = item[0].rule_range;
                this.$refs.ueHouse.clearContent();
                this.$refs.ueHouse.pushContentHouse(data.content)
                if (data.time_bucket > 0) {
                    this.timeId = data.time_bucket + '';
                }

            });

        },
        changeRule(id) {
            let item = this.rulesList.filter(item => item.id == id)
            this.ruleInfo = item[0].rule_range;
            this.info.num='',
            this.info.content='',
            this.info.highest_price='',
            this.info.lowest_price='',
            this.info.condition={
                sale_info: [],
                district: "",
                subway: "",
                layout: [],
                type_id: [],
                price_start: "",
                price_end: "",
                price_rand: false,
                total_price_start: "",
                total_price_end: "",
                total_price_rand: false,
                area_start: "",
                area_end: "",
                area_rand: false
            }
        },
        changeC(val) { },
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if(Number(this.info.condition.price_start) && Number(this.info.condition.price_end)){
                            if(Number(this.info.condition.price_start) > Number(this.info.condition.price_end)){
                                this.$message({
                                message: '单价区间最小值不能大于最大值',
                                type: 'error',
                                duration: 3 * 1000
                            })
                            return false
                        }
                    }
                    if(Number(this.info.condition.total_price_start) &&  Number(this.info.condition.total_price_end)){
                        if(Number(this.info.condition.total_price_start) > Number(this.info.condition.total_price_end)){
                            this.$message({
                                message: '总价区间最小值不能大于最大值',
                                type: 'error',
                                duration: 3 * 1000
                            })
                            return false
                        }
                    }
                    if(Number(this.info.condition.area_start) && Number(this.info.condition.area_end)){
                        if(Number(this.info.condition.area_start) > Number(this.info.condition.area_end)){
                            this.$message({
                                message: '建面区间最小值不能大于最大值',
                                type: 'error',
                                duration: 3 * 1000
                            })
                            return false
                        }
                    }
                    this.info.condition.sale_info = this.info.condition.sale_info.join("_")
                    this.info.condition.district = this.info.condition.district ? 1:0
                    this.info.condition.subway = this.info.condition.subway ? 1:0
                    this.info.condition.layout = this.info.condition.layout.join("_")
                    this.info.condition.type_id = this.info.condition.type_id.join("_")
                    this.info.condition.price_start = Number(this.info.condition.price_start)
                    this.info.condition.price_end = Number(this.info.condition.price_end)
                    this.info.condition.price_rand = this.info.condition.price_rand ? 1:0
                    this.info.condition.total_price_start = Number(this.info.condition.total_price_start)
                    this.info.condition.total_price_end = Number(this.info.condition.total_price_end)
                    this.info.condition.total_price_rand = this.info.condition.total_price_rand ? 1:0
                    this.info.condition.area_start = Number(this.info.condition.area_start)
                    this.info.condition.area_end = Number(this.info.condition.area_end)
                    this.info.condition.area_rand = this.info.condition.area_rand ? 1:0
                    this.info.lowest_price = Number(this.info.lowest_price);
                    this.info.highest_price = Number(this.info.highest_price);
                    let that = this;
                    that.info.content = that.$refs.ueHouse.getContent().html;
                    let _imgArr = that.$refs.ueHouse.getContent().html.indexOf('houseUnit') > -1
                    if (_imgArr) {
                        if (this.cardId) {
                            if (this.info.time_bucket == 0) delete this.info.time_bucket
                            if (this.info.rules_id == 10) {
                                this.info.time_bucket = this.timeId
                            }
                            this.edit()
                        } else {
                            if (this.info.rules_id == 10) {
                                this.info.time_bucket = this.timeId
                            }
                            this.insert()
                        }
                    } else {
                        this.$message({
                            message: '楼盘卡片不可删除，请重新操作',
                            type: 'error',
                            duration: 3 * 1000
                        })
                        return false
                    }

                } else {
                    return false
                }
            })
        },
        getText(data){
            let condition = JSON.parse(data.condition);
            let text = ''
            if(condition.sale_info){
                text+=condition.sale_info.split("_").map((item)=>{
                    return this.saleInfoList[item-1].name
                }).join("、")
            }
            if(condition.district == 1){
                text+=",随机一个区域"
            }
            if(condition.subway == 1){
                text += ",随机一条地铁线路"
            }
            if(condition.layout){
                text += ','+condition.layout.split("_").map((item)=>{
                    return this.layoutList[item-1].name
                }).join("、")
            }
            if(condition.type_id){
                text += ','+condition.type_id.split("_").map((item)=>{
                    return this.typeIdList[item-1].name
                }).join("、")
            }
            if(condition.price_start || condition.price_end){
                if(condition.price_start > 0 && condition.price_start != 0 && (!condition.price_end || condition.price_end == 0)){
                    text += ','+condition.price_start+"元以上"
                }else if((!condition.price_start || condition.price_start == 0) && condition.price_end>0 && condition.price_end != 0){
                    text += ','+condition.price_end+"元以下"
                }else if(condition.price_start && condition.price_end && condition.price_start !=0 && condition.price_end !=0){
                    text += ','+condition.price_start+"-"+condition.price_end+"元/㎡"
                }
            }
            if(condition.price_rand == 1){
                text += ',随机单价区间'
            }
            if(condition.total_price_start || condition.total_price_end){
                if(condition.total_price_start > 0 && condition.total_price_start !=0 && (!condition.total_price_end || condition.total_price_end == 0)){
                    text += ','+condition.total_price_start+"万元以上"
                }else if((!condition.total_price_start || condition.total_price_start == 0) && condition.total_price_end>0 && condition.total_price_end !=0){
                    text += ','+condition.total_price_end+"万元以下"
                }else if(condition.total_price_start && condition.total_price_end && condition.total_price_start !=0 && condition.total_price_end != 0){
                    text += ','+condition.total_price_start+"-"+condition.total_price_end+"万元/每套"
                }
            }
            if(condition.total_price_rand == 1){
                text += ',随机总价区间'
            }
            if(condition.area_start || condition.area_end){
                if(condition.area_start > 0 && condition.area_start != 0 && (!condition.area_end || condition.area_end == 0)){
                    text += ','+condition.area_start+"㎡以上"
                }else if((!condition.area_start || condition.area_start == 0) && condition.area_end>0 && condition.area_end != 0){
                    text += ','+condition.area_end+"㎡以下"
                }else if(condition.area_start && condition.area_end && condition.area_start !=0 && condition.area_end != 0){
                    text += ','+condition.area_start+"-"+condition.area_end+"㎡"
                }
            }
            if(condition.area_rand == 1){
                text += ',随机建面区间'
            }
            return text
        },
        insert() {
            insertHouse(this.info).then((data) => {
                this.$message({
                    message: '添加成功',
                    type: 'success',
                    duration: 3 * 1000
                })
                this.resetForm()
                this.hide()
                let text  = this.getText(data);
                data.text = text
                this.$emit('insertHouseCard', data)
            }).catch(err => {
                const message = err.message
                this.$message({
                    message: message || '添加失败',
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        },
        edit() {

            editInsertHouse(this.cardId, this.info).then((data) => {
                this.$message({
                    message: '编辑成功',
                    type: 'success',
                    duration: 3 * 1000
                })
                this.resetForm()
                this.hide()
                let text  = this.getText(data);
                data.text = text
                this.$emit('insertHouseCard', data)
            }).catch(err => {
                const message = err.message
                this.$message({
                    message: message || '编辑失败',
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        }
    },
}
</script>

<style scoped>
.form-container .form-item{
    padding-bottom: 0;
}
.remark {
    font-size: 14px;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.85);
    position: relative;
    top: 20px;
    padding-left: 30px;
}

.rangePrice .el-form-item {
    width: 170px;
    float: left;
}

.tip2 {
    width: 100%;
    margin-top: 4px;
    color: red;
}
</style>
